import i18n, { BackendModule, ReadCallback } from 'i18next';
import { initReactI18next } from "react-i18next";
import intervalPlural from 'i18next-intervalplural-postprocessor';
import dayjs from 'dayjs';

const supportedLngs = ['sv', 'en'];

function detectInitialLanguage(): string {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get('lang');
    if (langParam && supportedLngs.includes(langParam)) return langParam;
  }
  return 'sv';
}

class StaticBackend implements BackendModule {
  type = 'backend' as const;

  static type = 'backend' as const;

  async read(language: string, namespace: string, callback: ReadCallback) {
    const result = await fetch(`/i18n/${language}.json`).then(res => res.json()).catch(() => null);
    callback(null, result?.[namespace] || {});
    dayjs.locale(language);
  }
}

i18n
  .use(intervalPlural)
  .use(initReactI18next)
  .use(StaticBackend)
  .init({
    lng: detectInitialLanguage(),
    fallbackLng: 'sv',
    supportedLngs,
    load: 'languageOnly',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
